import { Type } from '@sinclair/typebox';
import { DataExchangeTypes } from '../../enums/DataExchangeTypes';
import { createPathGuidParameter } from '../../routes/createPathParameter';

export const zxyDataExchangePaths = {
    '/api/request/objects/{authorizationRequestId}': {
        parameters: [createPathGuidParameter('authorizationRequestId')],
        get: {
            operationId: 'zxyDataExchangeRequesterController.getObjects',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    location: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
            parameters: [{ name: 'name', in: 'query', schema: Type.String() }],
        },
    },
    '/api/request/{authorizationRequestId}': {
        parameters: [createPathGuidParameter('authorizationRequestId')],
        post: {
            operationId: 'zxyDataExchangeRequesterController.processDataExchangeRequest',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                isSuccessful: Type.Boolean(),
                                message: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            targetObjectId: Type.Optional(Type.String()),
                            sourceObjectId: Type.Optional(Type.String()),
                            sourceSurvey: Type.Optional(Type.String()),
                            action: Type.Enum(DataExchangeTypes),
                            objectTypeId: Type.Optional(Type.String()),
                            companyOwnerId: Type.Optional(Type.String()),
                            surveyId: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
    },
} as const;
